/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PatchManagementResourceHistory {
    getFixupPrototypeFunction() { return PatchManagementResourceHistory.fixupPrototype; }

    static newInstance(model: Partial<PatchManagementResourceHistory>): PatchManagementResourceHistory {
        let obj = Object.assign(new PatchManagementResourceHistory(), model);
        PatchManagementResourceHistory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PatchManagementResourceHistory>): PatchManagementResourceHistory {
        if (!model) return null;
        return PatchManagementResourceHistory.newInstance(<PatchManagementResourceHistory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PatchManagementResourceHistory) {
        if (!obj) return;

        models.PatchManagementResourceHistory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PatchManagementResourceHistory): boolean {
        Object.setPrototypeOf(obj, PatchManagementResourceHistory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (typeof this.last_no_reboot_install_operation_time === "string") {
            this.last_no_reboot_install_operation_time = new Date(<string><any>this.last_no_reboot_install_operation_time);
        }
        if (typeof this.operation_start_time === "string") {
            this.operation_start_time = new Date(<string><any>this.operation_start_time);
        }
        if (typeof this.operation_end_time === "string") {
            this.operation_end_time = new Date(<string><any>this.operation_end_time);
        }
        if (typeof this.next_maintenance === "string") {
            this.next_maintenance = new Date(<string><any>this.next_maintenance);
        }
        if (typeof this.previous_maintenance === "string") {
            this.previous_maintenance = new Date(<string><any>this.previous_maintenance);
        }
        if (this.AWS) {
            models.PatchManagementAwsResourceDetails.fixupPrototype(this.AWS);
        }
        if (this.azure) {
            models.PatchManagementAzureResourceDetails.fixupPrototype(this.azure);
        }
    }

    /**
     * ID of the cloud account
     */
    cloud_account_id: string;

    /**
     * Resource identifier id of the resource
     */
    cloud_native_resource_id: string;

    /**
     * Region name
     */
    region: string;

    /**
     * Resource group name
     */
    resource_group: string;

    /**
     * Location of the resource
     */
    location: string;

    /**
     * Name of the category
     */
    resource_category: string;

    /**
     * Name of the component
     */
    resource_type: string;

    /**
     * Name of the resource
     */
    resource: string;

    /**
     * Resource Patch history record creation time
     */
    created_at: Date;

    /**
     * Resource Patch history last updated time
     */
    updated_at: Date;

    /**
     * Time of the last attempt to patch the managed node
     */
    last_no_reboot_install_operation_time: Date;

    /**
     * Patch operation started time for the node
     */
    operation_start_time: Date;

    /**
     * Patch operation completed time for the node
     */
    operation_end_time: Date;

    /**
     * AWS patch details
     */
    AWS: models.PatchManagementAwsResourceDetails;

    /**
     * Azure patch details
     */
    azure: models.PatchManagementAzureResourceDetails;

    /**
     * Next maintenance window for the resource
     */
    next_maintenance: Date;

    /**
     * Previous maintenance window for the resource
     */
    previous_maintenance: Date;

}
